import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/loss-reasons'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'loss_reasons_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'loss_reasons_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'loss_reasons_list',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
